<div class="header">
  <div class="title">
    <span *ngIf="projectionData.id">{{ "edit_projection" | localize }}</span>
    <span *ngIf="!projectionData.id">{{ "set_projection" | localize }}</span>
  </div>

  <button (click)="close()" ui-modal-close></button>
</div>

<form class="projection-form" [formGroup]="projectionForm" (ngSubmit)="onSubmit()" ui-form>
  <ui-form-item ui-row>
    <ui-form-control [uiXs]="24" [uiErrorTip]="'the_value_is_required' | localize" uiValidateStatus="error">
      <ui-input-number-group [uiAddOnBefore]="kpi.formatting.prefix" [uiAddOnAfter]="kpi.formatting.suffix" [uiAddonStyle]="{ maxWidth: '100px' }" uiSize="large">
        <ui-input-number
          [useThousandsFormatter]="true"
          [uiAutoFocus]="true"
          [a11yDisabled]="false"
          [a11yRequired]="true"
          [uiPlaceHolder]="'enter_value' | localize"
          uiSize="large"
          formControlName="value"></ui-input-number>
      </ui-input-number-group>
    </ui-form-control>
  </ui-form-item>
  <ui-form-item ui-row>
    <ui-form-control [uiXs]="24">
      <ui-date-picker [uiDisabledDate]="isDateDisabled.bind(this)" formControlName="date"></ui-date-picker>
    </ui-form-control>
  </ui-form-item>
  <ui-form-item class="form-actions-item" ui-row>
    <ui-form-control [uiXs]="{ span: 24, offset: 0 }">
      <div class="form-actions">
        <button
          *ngIf="projectionData.id"
          [disabled]="isHttpRequestInProgress"
          [uiDanger]="true"
          (click)="onDelete()"
          type="button"
          ui-button
          uiType="link"
          uiShape="round"
          data-test-id="delete-projection-button">
          {{ "delete" | localize }}
        </button>
        <button [disabled]="isHttpRequestInProgress" (click)="close()" type="button" ui-button uiType="default" uiShape="round">{{ "cancel" | localize }}</button>
        <button [disabled]="!projectionForm.valid || isHttpRequestInProgress" type="submit" ui-button uiType="primary" uiShape="round" data-test-id="submit-projection-button">
          <span *ngIf="projectionData.id">{{ "confirm" | localize }}</span>
          <span *ngIf="!projectionData.id">{{ "set_projection" | localize }}</span>
        </button>
      </div>
    </ui-form-control>
  </ui-form-item>
</form>
